export const FLASHCARDS = [
  {
    "id": 1,
    "topic_id": 2,
    "title": "What are the three key objectives of information security?",
    "description": "Confidentiality, integrity, and availability (CIA)."
  },
  {
    "id": 2,
    "topic_id": 1,
    "title": "Risk exists at the intersection of _______ and _________.",
    "description": "Threats and vulnerabilities."
  },
  {
    "id": 3,
    "topic_id": 1,
    "title": "What is the overall risk rating for a risk that has medium likelihood and high impact?",
    "description": "High."
  },
  {
    "id": 4,
    "topic_id": 2,
    "title": "What type of system controls access to a network based on criteria such as time of day, location, device type, and system health?",
    "description": "Network access control (NAC)."
  },
  {
    "id": 5,
    "topic_id": 2,
    "title": "What are the three networks typically connected to a triple-homed firewall?",
    "description": "The Internet, an internal network, and a screened subnet (DMZ)."
  },
  {
    "id": 6,
    "topic_id": 2,
    "title": "What is the TCP port for the HTTP protocol?",
    "description": "80."
  },
  {
    "id": 7,
    "topic_id": 3,
    "title": "What is the TCP port for the HTTPS protocol?",
    "description": "443."
  },
  {
    "id": 8,
    "topic_id": 1,
    "title": "What are the four types of firewalls?",
    "description": "Packet filters, stateful inspection firewalls, next-generation firewalls, and web application firewalls."
  },
  {
    "id": 9,
    "topic_id": 3,
    "title": "______ may be used to apply settings to many different Windows systems at the same time.",
    "description": "Group Policy Objects (GPOs)."
  },
  {
    "id": 10,
    "topic_id": 1,
    "title": "What are the four phases of penetration testing?",
    "description": "Planning, Discovery, Attack, and Reporting."
  },
  {
    "id": 11,
    "topic_id": 2,
    "title": "What type of software can you use to enumerate the services that are accepting network connections on a remote system without probing that system for vulnerabilities?",
    "description": "Port scanner."
  },
  {
    "id": 12,
    "topic_id": 3,
    "title": "What is the range of well-known ports?",
    "description": "0\u20131023."
  },
  {
    "id": 13,
    "topic_id": 4,
    "title": "What is the range of registered ports?",
    "description": "1024\u201349151."
  },
  {
    "id": 14,
    "topic_id": 3,
    "title": "What is the most commonly used port scanner?",
    "description": "nmap."
  },
  {
    "id": 15,
    "topic_id": 3,
    "title": "What service is responsible for resolving domain names to IP addresses?",
    "description": "DNS."
  },
  {
    "id": 16,
    "topic_id": 1,
    "title": "What service allows you to look up the registered owner of a domain name?",
    "description": "Whois."
  },
  {
    "id": 17,
    "topic_id": 2,
    "title": "What type of data analysis looks for differences from expected behaviors?",
    "description": "Anomaly analysis."
  },
  {
    "id": 18,
    "topic_id": 1,
    "title": "What type of data analysis predicts threats based on existing data?",
    "description": "Trend analysis."
  },
  {
    "id": 19,
    "topic_id": 1,
    "title": "What regulation requires vulnerability scans for organizations involved in credit card processing?",
    "description": "PCI DSS."
  },
  {
    "id": 20,
    "topic_id": 1,
    "title": "What regulation requires vulnerability scanning for federal government agencies?",
    "description": "Federal Information Security Modernization Act (FISMA)."
  },
  {
    "id": 21,
    "topic_id": 2,
    "title": "What type of vulnerability scan leverages read-only access to the scan target?",
    "description": "Credentialed scan."
  },
  {
    "id": 22,
    "topic_id": 2,
    "title": "What term is used to describe an organization\u2019s willingness to tolerate risk?",
    "description": "Risk appetite."
  },
  {
    "id": 23,
    "topic_id": 2,
    "title": "What type of account should be used to perform credentialed vulnerability scans?",
    "description": "Read-only account."
  },
  {
    "id": 24,
    "topic_id": 2,
    "title": "What function is performed by Nessus and OpenVAS?",
    "description": "Vulnerability scanning."
  },
  {
    "id": 25,
    "topic_id": 2,
    "title": "What is the purpose of Nikto and Arachni?",
    "description": "Web application scanning."
  },
  {
    "id": 26,
    "topic_id": 2,
    "title": "What criteria should be used in prioritizing the remediation of vulnerabilities?",
    "description": "Criticality, difficulty, severity, and exposure."
  },
  {
    "id": 27,
    "topic_id": 2,
    "title": "What industry-standard system is used to assess the severity of security vulnerabilities?",
    "description": "CVSS."
  },
  {
    "id": 28,
    "topic_id": 2,
    "title": "What are the CVSS score ranges?",
    "description": "Under CVSS version 3.1, 0.1\u20133.9 is low, 4.0\u20136.9 is medium, 7.0\u20138.9 is high, and 9.0-10.0 is critical."
  },
  {
    "id": 29,
    "topic_id": 2,
    "title": "What is the term used to describe when a scanner reports a vulnerability that does not really exist?",
    "description": "False positive."
  },
  {
    "id": 30,
    "topic_id": 2,
    "title": "What type of vulnerability allows an attacker to place more data into an area of memory than is allocated for a specific purpose?",
    "description": "Buffer overflow."
  },
  {
    "id": 31,
    "topic_id": 3,
    "title": "What type of attack seeks to increase the level of access that an attacker has to a targeted system?",
    "description": "Privilege escalation."
  },
  {
    "id": 32,
    "topic_id": 3,
    "title": "What type of attack allows an attacker to run software of their choice on the targeted system?",
    "description": "Arbitrary code execution."
  },
  {
    "id": 33,
    "topic_id": 1,
    "title": "What is the current secure standard for providing HTTPS encryption?",
    "description": "TLS 1.2 or later."
  },
  {
    "id": 34,
    "topic_id": 3,
    "title": "In what type of attack does the attacker sends massive amounts of traffic from many different spoofed sources to a single target address?",
    "description": "Distributed denial of service (DDoS)."
  },
  {
    "id": 35,
    "topic_id": 1,
    "title": "What term is used to describe any observable occurrence in a system or network that relates to a security function?",
    "description": "Security event."
  },
  {
    "id": 36,
    "topic_id": 3,
    "title": "What are the phases of incident response?",
    "description": "Preparation; Detection & Analysis; Containment, Eradication, & Recovery; and Post-Incident Activity."
  },
  {
    "id": 37,
    "topic_id": 3,
    "title": "What type of documents provide the detailed, tactical information that CSIRT members need when responding to an incident?",
    "description": "Procedures."
  },
  {
    "id": 38,
    "topic_id": 3,
    "title": "What document serves as the cornerstone of an organization\u2019s incident response program?",
    "description": "Incident response policy."
  },
  {
    "id": 39,
    "topic_id": 1,
    "title": "What type of threat consists of highly skilled and talented attackers focused on a specific objective?",
    "description": "Advanced persistent threat (APT)."
  },
  {
    "id": 40,
    "topic_id": 4,
    "title": "What are the types of impact used to describe the scope of a security incident?",
    "description": "Functional impact, economic impact, and recoverability effort."
  },
  {
    "id": 41,
    "topic_id": 3,
    "title": "What are the common attack vectors for security incidents?",
    "description": "Common attack vectors for security incidents include external/removable media, attrition, the web, email, impersonation, improper usage, loss or theft of equipment, and other/unknown sources."
  },
  {
    "id": 42,
    "topic_id": 1,
    "title": "What term is used to describe traffic sent to a command and control system by a PC that is part of a botnet?",
    "description": "Beaconing."
  },
  {
    "id": 43,
    "topic_id": 1,
    "title": "What Windows tools provide information on memory, CPU, and disk use?",
    "description": "Perfmon, Resource Monitor, and Task Manager."
  },
  {
    "id": 44,
    "topic_id": 1,
    "title": "What protocol is used to gather information about and manage network devices?",
    "description": "SNMP."
  },
  {
    "id": 45,
    "topic_id": 1,
    "title": "What type of information is found in network flow data?",
    "description": "Flow data provides information about the source and destination IP address, protocol, and total data sent."
  },
  {
    "id": 46,
    "topic_id": 1,
    "title": "What protocol is used to ensure that all security devices on a network have synchronized clocks?",
    "description": "NTP."
  },
  {
    "id": 47,
    "topic_id": 1,
    "title": "What is the purpose of FTK, EnCase, SIFT, and the Sleuth Kit (TSK)?",
    "description": "Forensic toolkits."
  },
  {
    "id": 48,
    "topic_id": 3,
    "title": "What type of device is designed to copy drives for forensic investigation, and then provide validation that the original drive and the content of the new drive match?",
    "description": "Forensic drive duplicator."
  },
  {
    "id": 49,
    "topic_id": 1,
    "title": "Where can forensic analysts turn to find information about logins, service start/stop events, and evidence of applications being run on a Windows system?",
    "description": "Event logs."
  },
  {
    "id": 50,
    "topic_id": 3,
    "title": "What Linux utility is commonly used to clone drives in RAW format?",
    "description": "dd."
  },
  {
    "id": 51,
    "topic_id": 3,
    "title": "What type of device can ensure that attaching a drive to a forensic copy device or workstation does not result in modifications being made to drive, thus destroying the forensic integrity of the process?",
    "description": "Write blocker."
  },
  {
    "id": 52,
    "topic_id": 3,
    "title": "What is the first action that incident responders should take after identifying a potential incident?",
    "description": "Contain the damage."
  },
  {
    "id": 53,
    "topic_id": 3,
    "title": "Network segmentation, isolation, and removal of affected systems are examples of ___________ strategies.",
    "description": "Containment."
  },
  {
    "id": 54,
    "topic_id": 3,
    "title": "Once responders have contained the damage caused by an incident, they should move on to __________ and ________ steps.",
    "description": "Eradication and recovery."
  },
  {
    "id": 55,
    "topic_id": 3,
    "title": "At the conclusion of a cybersecurity incident response effort, CSIRT members should conduct a formal ____________ session.",
    "description": "Lessons learned."
  },
  {
    "id": 56,
    "topic_id": 3,
    "title": "What activities should always occur to validate an incident recovery effort?",
    "description": "Verify user accounts, verify permissions, verify logging, and conduct vulnerability scans."
  },
  {
    "id": 57,
    "topic_id": 3,
    "title": "What are the three options available for the secure disposition of media containing sensitive information?",
    "description": "Clear, purge, and destroy."
  },
  {
    "id": 58,
    "topic_id": 3,
    "title": "What is the focus of the recovery phase of incident response?",
    "description": "Restoring normal operations."
  },
  {
    "id": 59,
    "topic_id": 1,
    "title": "____________ is a time-consuming investigative task that often distracts incident responders and results in dead ends.",
    "description": "Identifying the attackers."
  },
  {
    "id": 60,
    "topic_id": 1,
    "title": "________ are high-level statements of management intent.",
    "description": "Policies."
  },
  {
    "id": 61,
    "topic_id": 4,
    "title": "_______ outline what information the organization will maintain and the length of time different categories of information will be retained prior to destruction.",
    "description": "Data retention policies."
  },
  {
    "id": 62,
    "topic_id": 1,
    "title": "________ provide mandatory requirements describing how an organization will carry out its information security policies.",
    "description": "Standards."
  },
  {
    "id": 63,
    "topic_id": 1,
    "title": "__________ are detailed, step-by-step processes that individuals and organizations must follow in specific circumstances.",
    "description": "Procedures."
  },
  {
    "id": 64,
    "topic_id": 1,
    "title": "_________ provide best practices and recommendations related to a given concept, technology, or task.",
    "description": "Guidelines."
  },
  {
    "id": 65,
    "topic_id": 2,
    "title": "Many exception processes require the use of ___________________ to mitigate the risk associated with exceptions to security standards.",
    "description": "Compensating controls."
  },
  {
    "id": 66,
    "topic_id": 2,
    "title": "What type of controls include firewalls, intrusion detection and prevention systems, network segmentation, and authentication and authorization systems?",
    "description": "Technical (or logical) controls."
  },
  {
    "id": 67,
    "topic_id": 2,
    "title": "What type of controls involve processes and procedures like those found in incident response plans, account creation and management, as well as awareness and training efforts?",
    "description": "Managerial controls."
  },
  {
    "id": 68,
    "topic_id": 2,
    "title": "What type of controls include locks, fences, and other controls that control or limit physical access, as well as controls like fire extinguishers that can help to prevent harm to property?",
    "description": "Physical controls."
  },
  {
    "id": 69,
    "topic_id": 2,
    "title": "_____________ are intended to stop an incident from occurring by taking proactive measures to stop the threat.",
    "description": "Preventive controls."
  },
  {
    "id": 70,
    "topic_id": 1,
    "title": "A _______ is often used when services or systems need to be exposed to lower trust areas.",
    "description": "DMZ or screened subnet."
  },
  {
    "id": 71,
    "topic_id": 1,
    "title": "__________ is the steady accrual of additional rights over time as account owners change roles, positions, or responsibilities.",
    "description": "Privilege creep."
  },
  {
    "id": 72,
    "topic_id": 1,
    "title": "What are the stages of the software development life cycle?",
    "description": "Planning, Requirements, Design, Development, Testing, Training and Transition, Ongoing Operations and Maintenance, End-of-Life Decommissioning."
  },
  {
    "id": 73,
    "topic_id": 1,
    "title": "The _______ phase of the SDLC includes actual coding of the application.",
    "description": "Development."
  },
  {
    "id": 74,
    "topic_id": 1,
    "title": "What are the three types of system environments commonly used in organizations?",
    "description": "Development, Test, and Production."
  },
  {
    "id": 75,
    "topic_id": 1,
    "title": "In the _______ software development model, each phase follows sequentially and phases do not overlap.",
    "description": "Waterfall."
  },
  {
    "id": 76,
    "topic_id": 1,
    "title": "The _______ software development model is an iterative and incremental process.",
    "description": "Agile."
  },
  {
    "id": 77,
    "topic_id": 2,
    "title": "During the _______ phase of software development, security practitioners may be asked to participate in initial assessments or cost evaluations.",
    "description": "Feasibility."
  },
  {
    "id": 78,
    "topic_id": 2,
    "title": "____________ uses different techniques to allow developers to assess each others\u2019 code before release.",
    "description": "Code review."
  },
  {
    "id": 79,
    "topic_id": 2,
    "title": "What testing technique involves sending invalid or random data to an application to test its ability to handle unexpected data?",
    "description": "Fuzz testing or fuzzing."
  },
  {
    "id": 80,
    "topic_id": 4,
    "title": "What elements are commonly found in a vulnerability management report?",
    "description": "Vulnerabilities, affected hosts, risk score, mitigation options, recurrence, and prioritization information."
  },
  {
    "id": 81,
    "topic_id": 4,
    "title": "What are the categories of stakeholders who should receive a vulnerability report?",
    "description": "1. Technical stakeholders."
  },
  {
    "id": 82,
    "topic_id": 4,
    "title": "What is used to describe specific metrics like time to remediate or patch, and are set by an organization or are defined as part of a service level agreement with a vendor or service?",
    "description": "Service level objectives (SLOs)."
  },
  {
    "id": 83,
    "topic_id": 2,
    "title": "What are some common inhibitors to vulnerability remediation?",
    "description": "Memorandums of understanding, service-level agreements, organizational governance, business process interruption, degrading functionality, legacy systems, and proprietary systems."
  },
  {
    "id": 84,
    "topic_id": 3,
    "title": "What NIST reference describes an incident handling process?",
    "description": "NIST SP 800-61."
  },
  {
    "id": 85,
    "topic_id": 3,
    "title": "What type of incident analysis uses a principle-based, systems approach for the identification of underlying causes associated with a particular set of risks?",
    "description": "Root cause analysis."
  },
  {
    "id": 86,
    "topic_id": 3,
    "title": "What incident response metric measures how long it took from the initial event that resulted in an incident to when it was detected?",
    "description": "Mean time to detect."
  },
  {
    "id": 87,
    "topic_id": 4,
    "title": "What incident response metric measures the time from detection to assessing the event as an incident and activating the process?",
    "description": "Mean time to respond."
  },
  {
    "id": 88,
    "topic_id": 4,
    "title": "What incident response metric identifies the time required to resolve a problem?",
    "description": "Mean time to remediate."
  },
  {
    "id": 89,
    "topic_id": 4,
    "title": "What are the common elements of an incident response report?",
    "description": "Executive summary, narrative, recommendations, timeline, impact assessment, scope, and evidence."
  },
  {
    "id": 90,
    "topic_id": 1,
    "title": "What technology provides an alternative to virtualizing an entire system, and instead permits applications to be run in their own environment with their own required components?",
    "description": "Containerization."
  },
  {
    "id": 91,
    "topic_id": 2,
    "title": "Name three common system hardening practices.",
    "description": "Updating and patching the system."
  },
  {
    "id": 92,
    "topic_id": 1,
    "title": "What Windows Registry key contains system information including scheduled tasks and services?",
    "description": "HKEY_LOCAL_MACHINE (HKLM)."
  },
  {
    "id": 93,
    "topic_id": 1,
    "title": "What Windows Registry key contains information about the currently logged-in user?",
    "description": "HKEY_CURRENT_USER (HKCU)."
  },
  {
    "id": 94,
    "topic_id": 1,
    "title": "What is the core system process on a Windows system called?",
    "description": "The NT Kernel."
  },
  {
    "id": 95,
    "topic_id": 1,
    "title": "What switch technology provides for logical network segmentation?",
    "description": "VLANs."
  },
  {
    "id": 96,
    "topic_id": 1,
    "title": "What concept removes the trust that used to be placed in systems, services, and individuals inside security boundaries?",
    "description": "Zero-trust networking."
  },
  {
    "id": 97,
    "topic_id": 1,
    "title": "What are the three major factors used in multifactor authentication?",
    "description": "Something you know, something you have, and something you are."
  },
  {
    "id": 98,
    "topic_id": 1,
    "title": "What authorization technology allows users to share elements of their identity or account information while authenticating via the original identity provide?",
    "description": "OAuth."
  },
  {
    "id": 99,
    "topic_id": 1,
    "title": "What are the three main roles in a federated identity management system?",
    "description": "Identity Provider (IDP)."
  },
  {
    "id": 100,
    "topic_id": 200,
    "title": "Know the three objectives of cybersecurity.",
    "description": "Confidentiality ensures that unauthorized individuals are not able to gain access to sensitive information. Integrity ensures that there are no unauthorized modifications to information or systems, either intentionally or unintentionally. Availability ensures that information and systems are ready to meet the needs of legitimate users at the time those users request them."
  },
  {
    "id": 101,
    "topic_id": 200,
    "title": "Know how cybersecurity risks result from the combination of a threat and a vulnerability.",
    "description": "A vulnerability is a weakness in a device, system, application, or process that might allow an attack to take place. A threat in the world of cybersecurity is an outside force that may exploit a vulnerability."
  },
  {
    "id": 102,
    "topic_id": 200,
    "title": "Be able to categorize cybersecurity threats as adversarial, accidental, structural, or environmental.",
    "description": "Adversarial threats are individuals, groups, and organizations that are attempting to deliberately undermine the security of an organization. Accidental threats occur when individuals doing their routine work mistakenly perform an action that undermines security. Structural threats occur when equipment, software, or environmental controls fail due to the exhaustion of resources, exceeding their operational capability or simply failing due to age. Environmental threats occur when natural or human-made disasters occur that are outside the control of the organization."
  },
  {
    "id": 103,
    "topic_id": 200,
    "title": "Understand how networks are made more secure through the use of network access control, firewalls, and segmentation.",
    "description": "Network access control (NAC) solutions help security professionals achieve two cybersecurity objectives: limiting network access to authorized individuals and ensuring that systems accessing the organization's network meet basic security requirements. Network firewalls sit at the boundaries between networks and provide perimeter security. Network segmentation uses isolation to separate networks of differing security levels from each other."
  },
  {
    "id": 104,
    "topic_id": 200,
    "title": "Understand how endpoints are made more secure through the use of hardened configurations, patch management, Group Policy, and endpoint security software.",
    "description": "Hardening configurations includes disabling any unnecessary services on the endpoints to reduce their susceptibility to attack, ensuring that secure configuration settings exist on devices, and centrally controlling device security settings. Patch management ensures that operating systems and applications are not susceptible to known vulnerabilities. Group Policy allows the application of security settings to many devices simultaneously, and endpoint security software protects against malicious software and other threats."
  },
  {
    "id": 105,
    "topic_id": 200,
    "title": "Know that penetration tests provide organizations with an attacker's perspective on their security.",
    "description": "The NIST process for penetration testing divides tests into four phases: planning, discovery, attack, and reporting. The results of penetration tests are valuable security planning tools, since they describe the actual vulnerabilities that an attacker might exploit to gain access to a network."
  },
  {
    "id": 106,
    "topic_id": 200,
    "title": "Understand how reverse engineering techniques attempt to determine how hardware and software function internally.",
    "description": "Sandboxing is an approach used to detect malicious software based on its behavior rather than its signatures. Other reverse engineering techniques are difficult to perform, are often unsuccessful, and are quite time-consuming."
  },
  {
    "id": 107,
    "topic_id": 200,
    "title": "Know how machine learning technology facilitates cybersecurity analysis.",
    "description": "The area of greatest promise for future cybersecurity analytics tools is the continued adoption of machine learning techniques designed to automatically extract knowledge from the voluminous quantity of information generated by security systems. Machine learning techniques are already incorporated into many security analytics tools, providing automated analysis of data based on the experiences of other users of the tool."
  },
  {
    "id": 108,
    "topic_id": 200,
    "title": "Understand the importance of efficiency and process improvements to security operations.",
    "description": "Cybersecurity analysis is difficult, and sometimes tedious, work. Projects that work to streamline operations, standardize processes, and increase integrations of tools and technologies allow work to flow more smoothly. This not only boosts the efficiency and effectiveness of cybersecurity analysts but also reduces the likelihood of error."
  },
  {
    "id": 109,
    "topic_id": 200,
    "title": "Explain infrastructure concepts and designs.",
    "description": "Describe serverless, virtualization, and containerization concepts, where and why they are most often used and how they differ from each other."
  },
  {
    "id": 110,
    "topic_id": 200,
    "title": "Understand operating system concepts.",
    "description": "Explain system hardening and understand the role of system hardening in organizational security practices. Describe the Windows Registry, and why it is important as part of operating system security. Know common file structure information and configuration file locations for common operating systems like Windows and Linux. Describe system processes. Understand the role of hardware architecture in system security."
  },
  {
    "id": 111,
    "topic_id": 200,
    "title": "Understand critical operational elements of logging.",
    "description": "Explain why time synchronization is critical to log analysis and how synchronization is accomplished. Describe log levels and why choosing an appropriate logging level is important."
  },
  {
    "id": 112,
    "topic_id": 200,
    "title": "Explain network architecture concepts and technologies.",
    "description": "Describe the similarities and differences between on-premises, cloud, and hybrid networks as well as the security concerns for each model. Understand network segmentation and explain why it is useful and how it can be accomplished. Describe software-defined networking, zero trust, and secure access service edge technologies and designs."
  },
  {
    "id": 113,
    "topic_id": 200,
    "title": "Understand identity and access management.",
    "description": "Explain multifactor authentication, including authentication factors. Describe passwordless authentication. Understand single sign-on and its role in organizations. Explain federation and how federated identity works. Know the role and uses for privileged access management (PAM) and cloud access security brokers as part of identity infrastructure."
  },
  {
    "id": 114,
    "topic_id": 200,
    "title": "Describe how encryption is used to protect sensitive data.",
    "description": "Explain public key infrastructure and its common components. Understand SSL inspection, its uses and drawbacks. Explain how data loss prevention (DLP) is used and what is required for effective implementation. Describe sensitive data and know the differences between personal identifiable information and cardholder data."
  },
  {
    "id": 115,
    "topic_id": 200,
    "title": "Analyze network-related potentially malicious activity.",
    "description": "Understand how network bandwidth is consumed and how it is related to detecting and analyzing events. Identify and explain common network issues, including bandwidth consumption, beaconing, irregular peer-to-peer communications, scans, sweeps, traffic spikes, and unexpected traffic. Understand how to identify activity on unexpected ports as well as how to identify rogue devices."
  },
  {
    "id": 116,
    "topic_id": 200,
    "title": "Analyze host-related potentially malicious activity.",
    "description": "Monitoring system resource usage, including CPU, memory, and disk space, can help to identify malicious activity. Understand what unexpected processor, drive, and memory consumption can mean when searching for malicious activity and indicators of compromise. Explain how to identify unauthorized software, filesystem, privilege, and Registry changes as well as malicious processes and unauthorized changes. Leverage built-in system tools to search for and identify these events and changes. Describe data exfiltration and how to identify it. Explain scheduled tasks and how to search for unauthorized changes to them."
  },
  {
    "id": 117,
    "topic_id": 200,
    "title": "Analyze application-related potentially malicious activity.",
    "description": "Use tools and techniques to identify application-related anomalous activity by reviewing logs, searching for unexpected new accounts and improper privileges. Review applications for unexpected output and outbound communications that may indicate malicious activity. Identify service interruptions using tools like log analysis and monitoring."
  },
  {
    "id": 118,
    "topic_id": 200,
    "title": "Explain and understand the uses of tools in identifying malicious activity.",
    "description": "Understand and use packet capture tools like Wireshark and tcpdump. Interpret output from both tools. Explain the uses of SIEM, SOAR, and EDR as well as their differences. Understand the use of DNS and IP reputation services as well as the role of Whois information and abuse databases like AbuseIPDB. Perform file analysis and interpret output of tools like strings and VirusTotal. Explain the purpose and uses of sandboxing tools, including Joe Sandbox and Cuckoo Sandbox, as well as general sandboxing concepts."
  },
  {
    "id": 119,
    "topic_id": 200,
    "title": "Use common techniques to identify malicious activity.",
    "description": "Leverage pattern recognition techniques to identify malicious activity, particularly command-and-control (C&C) by searching for beaconing and similar indicators. Understand commons Linux and Windows commands, know why they might be suspicious, and interpret them. Perform common email analysis including headers. Explain why embedded links can be dangerous. Understand DKIM, DMARC, and SPF. Conduct file analysis using hashing and other tools. Leverage user behavior analysis techniques to identify abnormal account activity like impossible travel."
  },
  {
    "id": 120,
    "topic_id": 200,
    "title": "Leverage programming languages and data formats as part of malicious activity identification.",
    "description": "Read and understand both JSON and XML. Read and understand what Python, PowerShell, and Linux shell scripts are doing. Use basic regular expressions for data and file analysis."
  },
  {
    "id": 121,
    "topic_id": 200,
    "title": "Describe threats actors classification standards and common terms.",
    "description": "Explain and differentiate types of threat actors, including advanced persistent threats (APTs), nation-states, hacktivists, organized crime, script kiddies, and both intentional and unintentional insider threats. Understand why supply chain threats are increasingly considered by organizations as well."
  },
  {
    "id": 122,
    "topic_id": 200,
    "title": "Describe tactics, techniques, and procedures.",
    "description": "Explain TTP, or tactics, techniques, and procedures that are the behaviors of threat actors. Tactics are high-level descriptions of how the threat actor behaves and what its strategies are. Techniques are the technical and nontechnical tools used to gain, maintain, and preserve access, to obtain information, and to perform other actions. Procedures are the processes threat actors use to sequence and leverage techniques to meet tactical and strategic goals."
  },
  {
    "id": 123,
    "topic_id": 200,
    "title": "Understand how open and closed source intelligence is collected and where it is acquired.",
    "description": "Describe both open source and closed source or proprietary threat intelligence sources. Understand that OSINT, or open source intelligence, can come from a variety of sources such as social media, blogs and forums, government bulletins, security organizations like CSIRTs and CERTs, and the dark web. Describe how intelligence sharing communities can provide threat data specifically targeted at industries or professional groups. Explain how to assess intelligence sources based on their timeliness, how relevant the data is to your needs, and how accurate the sources are by establishing confidence levels."
  },
  {
    "id": 124,
    "topic_id": 200,
    "title": "Explain threat hunting and IOCs.",
    "description": "Understand what indicators of compromise are and how they are gathered, analyzed, and applied. Explain common focus areas for threat hunters, including configurations and misconfigurations, as well as why isolated networks are useful when instrumenting and monitoring for attacks. Describe why organizations focus on business-critical assets and processes in their threat hunting prioritization. Explain active defense techniques, including honeypots."
  },
  {
    "id": 125,
    "topic_id": 200,
    "title": "Explain how active reconnaissance is critical to asset discovery and mapping.",
    "description": "Active reconnaissance involves probing systems and networks for information. Port scanning is a frequent first step during reconnaissance, and nmap is a commonly used tool for system, port, OS, and service discovery for part scanning. Active reconnaissance can also help determine network topology by capturing information and analyzing responses from network devices and systems. It is important to know common port and service pairings to help with analyzing and understanding discovered services."
  },
  {
    "id": 126,
    "topic_id": 200,
    "title": "Know how passive discovery provides information without active probes.",
    "description": "Passive discovery relies on data gathered without probing systems and networks. Log files, configuration files, and published data from DNS and Whois queries can all provide valuable data without sending any traffic to a system or network. Packet capture is useful when working to understand a network and can help document active reconnaissance activities as well as providing diagnostic and network data."
  },
  {
    "id": 127,
    "topic_id": 200,
    "title": "Assess data from common tools.",
    "description": "Tools like the Angry IP Scanner and nmap can be used for asset discovery and mapping. Maltego and Recon-ng are useful for mapping and organizing open source intelligence as well as reconnaissance data. The Metasploit Framework includes both information-gathering and exploit tools as well as other functions. Understand the uses of these tools, their basic functionality, and how to read output from them."
  },
  {
    "id": 128,
    "topic_id": 200,
    "title": "Explain asset discovery and device fingerprinting.",
    "description": "Asset discovery helps organizations identify what they have on their networks and what services are exposed on systems and devices. Understanding topology, operating systems, services, and hosts is important to ensuring you have an accurate map of the network. Network mapping scans, operating system and service detection and their accuracy, and topological information like time to live all play a part in this process."
  },
  {
    "id": 129,
    "topic_id": 200,
    "title": "Know that requirements for vulnerability scanning may come from both internal and external sources.",
    "description": "In some cases, organizations may face legal and regulatory requirements to conduct vulnerability scanning. The Payment Card Industry Data Security Standard (PCI DSS) and the Federal Information Security Management Act (FISMA) are two examples of these external requirements. In other cases, scanning may be driven by internal requirements, such as organizational policy."
  },
  {
    "id": 130,
    "topic_id": 200,
    "title": "Know the criteria for selecting scan targets.",
    "description": "Discovery scans provide organizations with an automated way to identify hosts that exist on the network and build an asset inventory. Cybersecurity professionals may then select scan targets based on data classification, system exposure, services offered, and the status of the system as a test, development, or production environment."
  },
  {
    "id": 131,
    "topic_id": 200,
    "title": "Describe how scan frequency will vary based on the needs of the organization.",
    "description": "Administrators may choose to run scans on a daily, weekly, or monthly basis depending on the organization's risk appetite, regulatory requirements, licensing limitations, and business and technical constraints. Some organizations may choose to adopt continuous monitoring approaches to vulnerability detection."
  },
  {
    "id": 132,
    "topic_id": 200,
    "title": "Explain how configuring scan settings allows customization to meet the organization's security requirements.",
    "description": "Cybersecurity professionals may customize scans by configuring the sensitivity level, including and excluding plug-ins, and supplementing basic network scans with information gathered from credentialed scans and server-based agents. Security teams may also conduct scans from more than one scan perspective, providing different views of the network."
  },
  {
    "id": 133,
    "topic_id": 200,
    "title": "Name the tasks administrators who are responsible for maintaining vulnerability scanning systems should perform.",
    "description": "Administrators responsible for maintaining vulnerability scanning systems should perform two important administrative tasks. First, they should update the scanner software on a regular basis to correct security issues and add new functionality. Second, they should update plug-ins frequently to provide the most accurate and up-to-date vulnerability scans of their environment."
  },
  {
    "id": 134,
    "topic_id": 200,
    "title": "Describe the remediation workflow organizations should use to identify, remediate, and test vulnerabilities.",
    "description": "Remediation workflows should be as automated as possible and integrate with other workflow technology used by the IT organization. As technologists correct vulnerabilities, they should validate that the remediation was effective through security testing and close out the vulnerability in the tracking system. The vulnerability management system should provide a range of reporting and alerting tools to supplement these efforts."
  },
  {
    "id": 135,
    "topic_id": 200,
    "title": "Know that cybersecurity professionals should prioritize remediation activities to make effective use of limited resources.",
    "description": "It simply isn't possible to correct every vulnerability immediately. Security teams should prioritize their work based on the criticality of the systems and information affected by the vulnerability, the difficulty of remediating the vulnerability, the severity of the vulnerability, and the exposure of the affected system."
  },
  {
    "id": 136,
    "topic_id": 200,
    "title": "Know how cybersecurity professionals must prepare to overcome objections to scanning from other members of the IT team.",
    "description": "Common objections to vulnerability scanning include the effect that service degradation caused by scanning will have on IT services, commitments to customers in MOUs and SLAs, and the use of IT governance and change management processes."
  },
  {
    "id": 137,
    "topic_id": 200,
    "title": "Explain how vulnerability scan reports provide critical information to cybersecurity analysts.",
    "description": "In addition to providing details about the vulnerabilities present on a system, vulnerability scan reports also offer crucial severity and troubleshooting information. The report typically includes the request and response that triggered a vulnerability report as well as a suggested solution to the problem. Analysts must understand how to identify, validate, and remediate vulnerabilities that occur."
  },
  {
    "id": 138,
    "topic_id": 200,
    "title": "Know the purpose of the Common Vulnerability Scoring System (CVSS).",
    "description": "The CVSS base score computes a standard measure on a 10-point scale that incorporates information about the access vector required to exploit a vulnerability, the complexity of the exploit, and the authentication required to execute an attack. The base score also considers the impact of the vulnerability on the confidentiality, integrity, and availability of the affected system."
  },
  {
    "id": 139,
    "topic_id": 200,
    "title": "Explain how servers and endpoint devices are a common source of vulnerability.",
    "description": "Missing patches and outdated operating systems are two of the most common vulnerability sources and are easily corrected by proactive device maintenance. Buffer overflow, privilege escalation, and arbitrary code execution attacks typically exploit application flaws. Devices supporting insecure protocols are also a common source of vulnerabilities."
  },
  {
    "id": 140,
    "topic_id": 200,
    "title": "Explain how critical infrastructure and specialized technologies add complexity to vulnerability scanning.",
    "description": "Cybersecurity analysts should understand how to conduct and interpret scans against mobile devices and operational technology (OT) components. Recognize the difficulty added by scanning vehicles, drones, building automation systems, physical access control systems, and industrial control systems."
  },
  {
    "id": 141,
    "topic_id": 200,
    "title": "Know that software vulnerabilities require cooperation between analysts and developers.",
    "description": "Web applications, in particular, are susceptible to SQL and XML injection attacks. All software may contain buffer, integer, and heap overflow vulnerabilities. Correcting these problems often requires rewriting code and rescanning vulnerable applications to confirm proper remediation."
  },
  {
    "id": 142,
    "topic_id": 200,
    "title": "Know how to analyze the indicators associated with application attacks.",
    "description": "Software applications may suffer from a wide range of vulnerabilities that make them susceptible to attack. You should be familiar with these attacks, including cross-site scripting, overflow vulnerabilities, data poisoning, broken access controls, cryptographic failures, injection flaws, request forgery attacks, and the many other ways that attackers can exploit application code. Understanding the methods behind these attacks helps security professionals build adequate defenses and identify attacks against their organizations."
  },
  {
    "id": 143,
    "topic_id": 200,
    "title": "Explain how risk identification and assessment helps organizations prioritize cybersecurity efforts.",
    "description": "Cybersecurity analysts seek to identify all the risks facing their organization and then conduct a business impact analysis to assess the potential degree of risk based on the probability that it will occur and the magnitude of the potential effect on the organization. This work allows security professionals to prioritize risks and communicate risk factors to others in the organization."
  },
  {
    "id": 144,
    "topic_id": 200,
    "title": "Know that vendors are a source of external risk.",
    "description": "Organizations should conduct their own systems assessments as part of their risk assessment practices, but they should conduct supply chain assessments as well. Performing vendor due diligence reduces the likelihood that a previously unidentified risk at a vendor will negatively impact the organization. Hardware source authenticity techniques verify that hardware was not tampered with after leaving the vendor's premises."
  },
  {
    "id": 145,
    "topic_id": 200,
    "title": "Describe a variety of risk management strategies.",
    "description": "Risk avoidance strategies change business practices to eliminate a risk. Risk mitigation techniques seek to reduce the probability or magnitude of a risk. Risk transference approaches move some of the risk to a third party. Risk acceptance acknowledges the risk and continues normal business operations despite the presence of the risk."
  },
  {
    "id": 146,
    "topic_id": 200,
    "title": "Understand the use of software security testing tools.",
    "description": "Static code analysis tools and techniques analyze the structure and content of code without executing the code itself. Dynamic analysis techniques actually execute the code. Fuzzing is a common dynamic testing technique that sends artificially generated input to an application. Debuggers are used to try to reverse-engineer the source code from an executable file."
  },
  {
    "id": 147,
    "topic_id": 200,
    "title": "Describe policy frameworks and what they consist of.",
    "description": "Policies are high-level statements of management intent for the information security program. Standards describe the detailed implementation requirements for policy. Procedures offer step-by-step instructions for carrying out security activities. Compliance with policies, standards, and procedures is mandatory. Guidelines offer optional advice that complements other elements of the policy framework. Frameworks used to set security approaches may be either prescriptive or risk-based."
  },
  {
    "id": 148,
    "topic_id": 200,
    "title": "Describe how organizations often adopt a set of security policies covering different areas of their security programs.",
    "description": "Common policies used in security programs include an information security policy, an acceptable use policy, a data ownership policy, a data retention policy, an account management policy, and a password policy. The specific policies adopted by any organization will depend on that organization's culture and business needs."
  },
  {
    "id": 149,
    "topic_id": 200,
    "title": "Know that policy documents should include exception processes.",
    "description": "Exception processes should outline the information required to receive an exception to security policy and the approval authority for each exception. The process should also describe the requirements for compensating controls that mitigate risks associated with approved security policy exceptions."
  },
  {
    "id": 150,
    "topic_id": 200,
    "title": "Distinguish between security events and security incidents.",
    "description": "An event is any observable occurrence in a system or network. A security event includes any observable occurrence that relates to a security function. A security incident is a violation or imminent threat of violation of computer security policies, acceptable use policies, or standard security practices. Every incident consists of one or more events, but every event is not an incident."
  },
  {
    "id": 151,
    "topic_id": 200,
    "title": "Name the four phases of the cybersecurity incident response process.",
    "description": "The four phases of incident response are preparation; detection and analysis; containment, eradication, and recovery; and post-incident activities. The process is not a simple progression of steps from start to finish. Instead, it includes loops that allow responders to return to prior phases as needed during the response."
  },
  {
    "id": 152,
    "topic_id": 200,
    "title": "Identify security event indicators.",
    "description": "Alerts originate from intrusion detection and prevention systems, security information and event management systems, antivirus software, file integrity checking software, and third-party monitoring services. Logs are generated by operating systems, services, applications, network devices, and network flows. Publicly available information exists about new vulnerabilities and exploits detected \u201cin the wild\u201d or in a controlled laboratory environment. People from inside the organization or external sources report suspicious activity that may indicate that a security incident is in progress."
  },
  {
    "id": 153,
    "topic_id": 200,
    "title": "Explain how policies, procedures, and playbooks guide incident response efforts.",
    "description": "The incident response policy serves as the cornerstone of an organization's incident response program. This policy should be written to guide efforts at a high level and provide the authority for incident response. Procedures provide the detailed, tactical information that CSIRT members need when responding to an incident. CSIRT teams often develop playbooks that describe the specific procedures that they will follow in the event of a specific type of cybersecurity incident."
  },
  {
    "id": 154,
    "topic_id": 200,
    "title": "Know that incident response teams should represent diverse stakeholders.",
    "description": "The core incident response team normally consists of cybersecurity professionals with specific expertise in incident response. In addition to the core team members, the CSIRT may include representation from technical subject matter experts, IT support staff, legal counsel, human resources staff, and public relations and marketing teams. The team will also need to coordinate with internal and external stakeholders, including senior leadership, law enforcement, and regulatory bodies."
  },
  {
    "id": 155,
    "topic_id": 200,
    "title": "Explain how incidents can be classified according to the attack vector where they originate.",
    "description": "Common attack vectors for security incidents include external/removable media, attrition, the web, email, impersonation, improper usage, loss or theft of equipment, and other/unknown sources."
  },
  {
    "id": 156,
    "topic_id": 200,
    "title": "Explain how response teams classify the severity of an incident.",
    "description": "The functional impact of an incident is the degree of impairment that it causes to the organization. The economic impact is the amount of financial loss that the organization incurs. In addition to measuring the functional and economic impact of a security incident, organizations should measure the time that services will be unavailable and the recoverability effort. Finally, the nature of the data involved in an incident also contributes to the severity as the information impact."
  },
  {
    "id": 157,
    "topic_id": 200,
    "title": "Be able to describe threats and attacks using frameworks and model them using analysis techniques.",
    "description": "Frameworks like the Diamond Model, the MITRE ATT&CK framework, and Lockheed Martin's Cyber Kill Chain all provide ways to assess and describe threats. Using a threat model can help to more fully understand a threat by identifying gaps. Tools like ATT&CK also provide a broad standard taxonomy for threats that allow you to use the data in tools compatible with the framework. Tools including the Open Source Testing Methodology Manual (OSS TMM) and the OWASP Testing Guide help you develop robust strategies for testing systems against the attacks identified in these frameworks."
  },
  {
    "id": 158,
    "topic_id": 200,
    "title": "Describe the importance of IoCs to incident detection and analysis.",
    "description": "List and understand common IoCs, including unusual network traffic unexpected peer-to-peer traffic; activity to unusual ports or IP addresses; increases in database or file share read volume; suspicious changes to filesystems, the Windows Registry, and configuration files; traffic patterns that are unusual for human usage of a system; and login and rights usage irregularities, including geographic and time-based anomalies, denial-of-service activities and artifacts, and unusual DNS traffic."
  },
  {
    "id": 159,
    "topic_id": 200,
    "title": "Investigate and describe IoCs.",
    "description": "Describe IoCs related to network traffic, resource usage, user and account behaviors, file and configuration modifications, privilege use, denial of service, and DNS traffic. Explain common examples of IoCs related to each topic, how you might leverage the IoCs, and what information from log files and other evidence might be relevant to identifying an indicator of compromise."
  },
  {
    "id": 160,
    "topic_id": 200,
    "title": "Understand evidence acquisition and preservation.",
    "description": "Evidence is commonly acquired and preserved as part of incident response activities, internal investigations, and due to legal holds as part of pending or current legal proceedings. Legal holds may require normal processes or procedures for data destruction or that limit lifespans of data to be suspended, or independent, verifiable copies may need to be made. Chain-of-custody documentation is created and maintained for legal and police investigations, but may also be created if investigations might become part of a legal proceeding."
  },
  {
    "id": 161,
    "topic_id": 200,
    "title": "Review log files and determine if an incident occurred.",
    "description": "Understand common log files and what to look for to determine if events recorded indicate an incident likely occurred or if log entries indicate normal behaviors."
  },
  {
    "id": 162,
    "topic_id": 200,
    "title": "Explain the purpose of containment activities.",
    "description": "After identifying a potential incident in progress, responders should take immediate action to contain the damage. They should select appropriate containment strategies based on the nature of the incident and impact on the organization. Potential containment activities include network segmentation, isolation, and removal of affected systems."
  },
  {
    "id": 163,
    "topic_id": 200,
    "title": "Know the importance of collecting evidence during a response.",
    "description": "Much of the evidence of a cybersecurity incident is volatile in nature and may not be available later if not collected during the response. CSIRT members must determine the priority that evidence collection will take during the containment, eradication, and recovery phase and then ensure that they properly handle any collected evidence that can later be used in legal proceedings, including properly preserving evidence, documenting the chain of custody, and validating data integrity."
  },
  {
    "id": 164,
    "topic_id": 200,
    "title": "Explain how identifying attackers can be a waste of valuable resources.",
    "description": "Most efforts to identify the perpetrators of security incidents are futile, consuming significant resources before winding up at a dead end. The primary focus of incident responders should be on protecting the business interests of the organization. Law enforcement officials have different priorities, and responders should be aware of potentially conflicting objectives."
  },
  {
    "id": 165,
    "topic_id": 200,
    "title": "Explain the purpose of eradication and recovery.",
    "description": "After containing the damage, responders should move on to eradication and recovery activities that seek to remove all traces of an incident from the organization's network and restore normal operations as quickly as possible. This should include validation efforts that verify security controls are properly implemented before closing the incident."
  },
  {
    "id": 166,
    "topic_id": 200,
    "title": "Define the purpose of post-incident activities.",
    "description": "At the conclusion of a cybersecurity incident response effort, CSIRT members should conduct a formal lessons learned session that reviews the entire incident response process and recommends changes to the organization's incident response plan, as needed. Any such changes should be made through the organization's change control process. The team should also complete a formal incident summary report that serves to document the incident for posterity. Other considerations during this process include evidence retention, indicator of compromise (IoC) generation, and ongoing monitoring."
  },
  {
    "id": 167,
    "topic_id": 200,
    "title": "Understand vulnerability management reporting.",
    "description": "Vulnerability reporting includes common elements like the CVE number and CVSS score, name, description, affected hosts, mitigation options, information about recurrence, and prioritization information. They need to be sent to the proper stakeholders in a regular and timely manner. Specific report types like compliance reports may be sent where appropriate. Action plans are then prepared to address the reports and may include configuration management, patching, compensating controls, awareness, education and training, and business requirement information."
  },
  {
    "id": 168,
    "topic_id": 200,
    "title": "Explain vulnerability management metrics and KPIs.",
    "description": "Trend data is used to determine whether a program is successful or if new issues are becoming systemic problems. Top 10 lists can help identify the most common vulnerabilities and thus help focus effort. Critical vulnerability lists also help with focus on the most dangerous vulnerabilities. Tracking zero-day vulnerabilities is challenging in reporting but may be required by leadership. Finally, service level objectives (SLOs) are set to define timely remediation goals and to determine if the organization is meeting them."
  },
  {
    "id": 169,
    "topic_id": 200,
    "title": "Describe inhibitors to remediation.",
    "description": "Memorandums of understanding (MOUs) and service level agreements (SLAs) define performance or uptime targets and may conflict with patching due to systems or services needing to be taken offline. Organizational governance may introduce slowdowns or additional requirements that impact patching. Concerns about business process interruption or degraded functionality due to patching may also impact patching. Finally, legacy systems and proprietary systems may not have patches available or patches may not be able to be installed while retaining support."
  },
  {
    "id": 170,
    "topic_id": 200,
    "title": "Understand critical stakeholders for incident response.",
    "description": "Stakeholders must be identified to ensure appropriate incident communication and reporting, and they need to be involved in incident declaration and escalation. Communications may need to involve legal, public relations with customers and media, regulatory reporting, and law enforcement."
  },
  {
    "id": 171,
    "topic_id": 200,
    "title": "List critical items for incident response reports.",
    "description": "Incident reports typically include executive summaries to describe the incident in an easily digestible, short form. They also must include who, what, when, where, and why information about the incident. Information about the impact, scope, and timeline, recommendations for improvement, and evidence related to the incident are also all commonly included. Root cause analyses help drive improvement to avoid future incidents of a similar nature."
  },
  {
    "id": 172,
    "topic_id": 200,
    "title": "Describe incident response metrics and KPIs.",
    "description": "Mean time to detect, mean time to respond, and mean time to remediate can all be useful information when attempting to assess the effectiveness of an incident response program. Measuring alert volume is less likely to provide useful data but may be requested by management."
  },
  {
    "id": 173,
    "topic_id": 200,
    "title": "Explain evidence acquisition tools, processes, and procedures.",
    "description": "Understand how and why evidence is acquired. Explain chain of custody and why it must be documented and preserved. Describe legal holds and preservation activities, what they are and when they may be required. Understand forensic analysis, including tools, processes and procedures needed to successfully acquire and analyze forensic data."
  },
  {
    "id": 174,
    "topic_id": 200,
    "title": "Be familiar with what's involved in a forensic investigation.",
    "description": "Describe forensic investigation processes, including scoping, identifying locations of relevant data, planning, acquisition, analysis, and reporting. Understand forensic targets, including system information, file modification, access, and other commonly acquired forensic data. Explain why acquisition requires forensic validation and care to not modify the source data, including the use of write blockers, as well as validating data integrity via hashing."
  },
  {
    "id": 175,
    "topic_id": 200,
    "title": "Describe post-incident activity.",
    "description": "Explain how and why forensic analysis may be used as part of an incident. Explain root cause analysis and lessons learned, when they occur, and what information they typically contain."
  }
];
